/** Platform / build-time flag: Open Knots module is available in this environment. */
export const isOpenKnotsEnvEnabled = () => {
    return String(process.env.REACT_APP_SHOW_OPEN_KNOTS).toLowerCase() === 'true';
};

/**
 * Whether the current user may see and use Open Knots (env flag + per-org IAM flag).
 * For buyers and suppliers, `userData.user_organizations[0].open_knots_enabled` must be true when the env flag is on.
 *
 * @param {object|null|undefined} userData - AuthContext user payload (same as after login).
 */
export const isOpenKnotsEnabled = (userData) => {
    if (!isOpenKnotsEnvEnabled()) return false;
    const role = userData?.user_organizations?.[0]?.user_org_role_maps?.[0]?.platform_role;
    if (role === 'buyer' || role === 'supplier') {
        return userData?.user_organizations?.[0]?.open_knots_enabled === true;
    }
    return true;
};
